import React, { SVGProps } from 'react'

const SvgCheckNew = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path d="M20 6L9 17L4 12" stroke={props.stroke ?? "#006E65"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
export default SvgCheckNew
